import React from 'react';
import { StyleSheet, css } from 'aphrodite';

export default class SkewBg extends React.Component{

  render(){
    return(
    	<div className={css(styles.mainContainer)}>
            <section className={css(styles.skewIntro)}>
            </section>
        </div>
    )
  }
}

const styles = StyleSheet.create({
    mainContainer : {
        position: 'relative'
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: 50,
        width: '100vw',
        height: 1080,
        overflow: 'hidden',
        transform: 'skewY(-12deg)',
        transformOrigin: 0,
        background: '#fffff',
    },
});


// WEBPACK FOOTER //
// ./src/Components/Home/InstaFeed/SkewBg.js